var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"403","title":"403","sub-title":"Sorry, you are not authorized to access this page."},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Back Home")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }